var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('el-tag',_vm._b({attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')},"close":function($event){return _vm.$emit('close')}}},'el-tag',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }